<template>
  <div class="row">
    <skill-form :skill="skill" @saved="getSkills(currentPage - 1)"/>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header justify-content-center">
          <h4>Yo'nalishlar</h4>
        </div>
        <div class="card-body">
          <transition name="fade" :duration="2000">
            <ul class="list-group list-group-flush" v-if="loaded">
              <li class="list-group-item list-group-item-action"
                  :class="{'active bg-gradient-primary': currentSkillId === skill.id}"
                  v-for="skill in skills" :key="skill.id"
                  @click="getSkillSubjects(skill.id)">
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{ skill.name }}</div>
                  <div>
                    <button class="btn btn-icon rounded-circle btn-flat-info waves-effect waves-light"
                            @click="editSkill(skill)" title="Tahrirlash">
                      <i style="font-size: 1.5rem" class="feather icon-edit"/>
                    </button>
                    <button class="btn btn-icon rounded-circle btn-flat-danger waves-effect waves-light"
                            @click="deleteSkill(skill.id)" title="O'chirish">
                      <i style="font-size: 1.5rem" class="feather icon-trash-2"/>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </transition>
          <div class="d-flex justify-content-center mt-1"
               v-if="skills.length > 0">
            <v-pagination
                v-model="currentPage"
                :classes="bootstrapPaginationClasses"
                :page-count="totalSize"
            />
          </div>
        </div>
      </div>
    </div>

    <Modal :modal="modal"
           @modal-closed="modal = false"
           :modal-size="'modal-sm'">
      <deleting-modal v-if="modal"
                      :delete-api="deleteApi"
                      @deleted="getSkills(currentPage - 1)"/>
    </Modal>

    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h4>Yo'nalish fanlari</h4>
        </div>
        <div class="card-body">
          <transition name="fade" :duration="2000">
            <ul class="list-group mb-1" v-if="loaded">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                  v-for="(skillSubject, index) in skillSubjects"
                  :key="skillSubject.id">
                <div>{{ index + 1 }}: {{ skillSubject.name }}</div>
                <button type="button" class="btn btn-icon btn-flat-danger rounded-circle waves-effect waves-light"
                        title="O'chirish"
                        @click="deleteReference(skillSubject.id)">
                  <i class="feather icon-trash-2"/>
                </button>
              </li>
            </ul>
          </transition>
          <div class="d-flex justify-content-end mb-1">
            <button class="btn btn-primary waves-effect waves-light"
                    @click="addReference">
              Fan qo'shish
            </button>
          </div>

          <div class="collapse" id="form-collapse">
            <div class="form-group">
              <multiselect v-model="selectedSubjects"
                           :options="subjects"
                           placeholder="Fanlar"
                           :multiple="true"
                           :close-on-select="false"
                           :clear-on-select="false"
                           open-direction="top"
                           label="name"
                           track-by="id"/>
            </div>
            <div class="form-group">
              <button class="btn btn-info waves-effect waves-light"
                      @click="storeReference">
                Saqlash
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
    <a href="#" class="d-none" ref="anchor"/>
  </div>
</template>

<script>
import SkillForm from "./SkillForm";

import Multiselect from 'vue-multiselect';
import vPagination from 'vue-plain-pagination'
import Modal from "../../components/Modal";
import DeletingModal from "../../components/DeletingModal";

export default {
  name: "Reference",
  components: {
    DeletingModal,
    Modal,
    SkillForm,
    Multiselect,
    vPagination,
  },
  data() {
    return {
      skills: [],
      skill: {},
      loaded: false,
      skillSubjects: [],
      subjects: [],
      selectedSubjects: [],
      currentSkillId: Number,
      totalSize: 1,
      currentPage: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination m-0',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      modal: false,
      deleteApi: ''
    };
  },
  methods: {
    getSkills(skip = 0) {
      this.loaded = true;
      this.$api.get(`admin/Reference/GetSkillList?skip=${skip}&take=10`)
          .then(res => {
            if (!res.error) {
              this.skills = res.result.data;
              this.totalSize = Math.ceil(res.result.total / 10);
              this.getSkillSubjects(res.result.data[0].id);
              this.skill = this.createSkillObject();
            }
          })
          .catch(err => {

          })
          .finally(() => {
            this.loaded = true;
          });

    },
    editSkill(skill) {
      this.skill = this.createSkillObject(skill);
      setTimeout(() => this.$refs.anchor.click(), 200);
    },
    deleteSkill(skillId) {
      this.deleteApi = `admin/Reference/DeleteSkill/${skillId}`;
      this.modal = true;
    },
    getSkillSubjects(id) {
      this.currentSkillId = id;
      $('#form-collapse').collapse('hide');
      this.$api.get(`admin/Reference/SkillSubjectList?skillId=${id}`)
          .then(res => {
            if (!res.error) {
              this.skillSubjects = res.result;
            }
          })
          .catch(err => {

          })
          .finally(() => {
          });
    },
    getSubjects() {
      this.$api.get('admin/List/SubjectList')
          .then(res => {
            if (!res.error) {
              this.subjects = res.result;
            }
          });
    },
    addReference() {
      $('#form-collapse').collapse('toggle');
    },
    storeReference() {
      let references = [];
      this.selectedSubjects.forEach(sub => {
        references.push({
          skillId: this.currentSkillId,
          subjectId: sub.id
        })
      });

      this.$api.post('admin/Reference/SkillSubjectPost', references)
          .then(res => {
            if (!res.error) {
              this.getSkillSubjects(this.currentSkillId);
              this.selectedSubjects = [];
              this.notificationMessage('Сохранено', 'success');
            }
          })
    },
    deleteReference(id) {
      this.$api.delete(`admin/Reference/SkillSubjectDelete/?id=${id}`)
          .then(res => {
            if (!res.error) {
              this.getSkillSubjects(this.currentSkillId);
              this.notificationMessage("Удалено", 'success');
            }
          });
    },

    createSkillObject(skill = null) {
      if (skill)
        return {
          id: skill.id,
          name: skill.name,
          picture: skill.picture
          // displayOrder: skill.displayOrder
        };
      else
        return {
          id: 0,
          name: '',
          picture: null,
          // displayOrder: null
        }
    },
  },
  watch: {
    currentPage() {
      this.getSkills(this.currentPage - 1);
    }
  },
  created() {
    this.getSkills();
    this.getSubjects();
    this.skill = this.createSkillObject();
  }
}
</script>
<style>
html {
  scroll-behavior: smooth;
}
</style>
<style scoped>

.list-group-item:hover {
  cursor: pointer;
}
</style>